import { createStrings } from '@utils/local';

export const partnerStrings = createStrings({
  ja: {
    truckCompany: 'トラック業者',
    partner: '業者',
    name_ja: '会社名（和文）',
    name_en: '会社名（英文）',
    short_name_en: '英文略称',
    fcNo: 'FC番号',
    pod: 'POD',
    contacts: '担当者',
    contactName: '担当者名',
    email: 'メール',
    address: '住所',
    tel: 'TEL',
    fax: 'FAX',
    phone: '携帯電話',
    logistics_center_address: '物流センター住所',
    type_description: 'その他の説明',
    contactAndEmail: '担当者＆メール',
    type: '業者区分',
    genbarai: '現払',
    shimebarai: '締め払',
    cutoffDate: '締め日',
    paymentDate: '支払日',
    customsPartner: '通関業者',
    transportPartner: '運送業者',
    warehousePartner: '倉庫業者',
    customsInspectionPartner: '税関検査業者',
    otherPartner: 'その他',
    registrationNumber: '登録番号',
    corporateNumber: '法人番号',
    paymentConditions: '支払条件',
    typeDescriptionIsRequired: 'その他の説明が必要です',
    memo1: '備考欄1',
    memo2: '備考欄2',
    errorNoSelectedDate: '日付を入力してください',
  },
});
